import { store, store$ } from '../../shared/services/state.service';
import { ImportLines, MapBounds } from '../interfaces/import-lines';
import { ImportType } from '../interfaces/import-type';
import * as importTypesActions from '../state/import-types.actions';
import * as importTypesSelectors from '../state/import-types.selectors';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map, skipWhile } from 'rxjs/operators';
import { NewImportType } from '../interfaces/dto/new-import-type';
import { UploadFile } from '../interfaces/upload-file';

/** Importing.. */

export function setFileImporting(bool: boolean): Observable<boolean> {
    store.dispatch(
        importTypesActions.importingFile(bool),
    );

    return fileImporting$();
}

export const fileImporting$ = (): Observable<boolean> => store$.pipe(
    map(state => importTypesSelectors.IMPORTING(state)),
    skipWhile(importing => importing === undefined),
    distinctUntilChanged(),
);

export function getImportTypes(): Observable<ImportType[]> {
    store.dispatch(
        importTypesActions.getImportTypesReq(),
    );

    return importTypes$();
}

export const importTypes$ = (): Observable<ImportType[]> => store$.pipe(
    map(state => importTypesSelectors.IMPORT_TYPES(state)),
    skipWhile(importTypes => importTypes === undefined),
    distinctUntilChanged(),
);

export function setAddImportTypeModal(flag: boolean): Observable<boolean> {
    store.dispatch(
        importTypesActions.setAddImportTypeModal(flag),
    );

    return addImportTypeModal$();
}

export const addImportTypeModal$ = (): Observable<boolean> => store$.pipe(
    map(state => importTypesSelectors.ADD_IMPORT_TYPE_MODAL(state)),
    distinctUntilChanged(),
);

export function createImportType(importType: NewImportType): Observable<ImportType[]> {
    store.dispatch(
        importTypesActions.createImportTypeReq(importType),
    );

    return importTypes$();
}

export const createImportTypeError$ = (): Observable<string> => store$.pipe(
    map(state => importTypesSelectors.ADD_IMPORT_TYPE_ERROR(state)),
    skipWhile(err => err === undefined),
    distinctUntilChanged(),
);

export function refreshTotals(): Observable<ImportType[]> {
    store.dispatch(
        importTypesActions.refreshTotalsReq(),
    );

    return importTypes$();
}

export function clearImportType(id: number): Observable<ImportType[]> {
    store.dispatch(
        importTypesActions.clearImportTypeReq(id),
    );

    return importTypes$();
}

export const clearImportTypeError$ = (): Observable<string> => store$.pipe(
    map(state => importTypesSelectors.CLEAR_IMPORT_TYPE_ERROR(state)),
    skipWhile(err => err === undefined),
    distinctUntilChanged(),
);

export function uploadGeoJsonFile(uploadFile: UploadFile): Observable<ImportType[]> {
    console.log(uploadFile)
    store.dispatch(
        importTypesActions.uploadGeoJsonFileReq(uploadFile),
    );

    return importTypes$();
}

export const uploadGeoJsonFileError$ = (): Observable<string> => store$.pipe(
    map(state => importTypesSelectors.UPLOAD_GEOJSON_FILE_ERROR(state)),
    skipWhile(err => err === undefined),
    distinctUntilChanged(),
);

/**
 * Demande les lignes d'un import pour la carte.
 * Sans bounds (clic sur le bouton de la grille), l'api renvoie un premier échantillon et le centre
 * où placer la carte ; avec bounds (déplacement de la carte), uniquement ce qui est visible.
 */
export function getImportLines(importTypeId: number, bounds?: MapBounds): Observable<ImportLines | null> {
    store.dispatch(
        importTypesActions.getImportLinesReq({ importTypeId, bounds }),
    );

    return importLines$();
}

// Pas de skipWhile : null est une valeur utile ici, c'est la carte vide
export const importLines$ = (): Observable<ImportLines | null> => store$.pipe(
    map(state => importTypesSelectors.IMPORT_LINES(state)),
    distinctUntilChanged(),
);

export const loadingImportLines$ = (): Observable<boolean> => store$.pipe(
    map(state => importTypesSelectors.LOADING_IMPORT_LINES(state)),
    distinctUntilChanged(),
);

export function clearImportLines(): Observable<ImportLines | null> {
    store.dispatch(
        importTypesActions.clearImportLines(),
    );

    return importLines$();
}